import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { axiosInstance } from './config';

// Internal API calls
const api = {
  createCheckout: async (plan) => {
    const { data } = await axiosInstance.post('/billing/checkout', { plan });
    return data;
  },
  getSubscription: async () => {
    const { data } = await axiosInstance.get('/billing/subscription');
    return data;
  },
  cancelScheduledChange: async () => {
    const { data } = await axiosInstance.post('/billing/cancel-schedule');
    return data;
  },
  cancelSubscription: async () => {
    const { data } = await axiosInstance.post('/billing/cancel');
    return data;
  },
  getBillingPortalUrl: async () => {
    const { data } = await axiosInstance.get('/billing/portal');
    return data;
  },
};

// Exported hooks
export const useCreateCheckout = () => {
  return useMutation({
    mutationFn: api.createCheckout,
    onSuccess: (data) => {
      if (data?.url) {
        window.location.href = data.url;
      }
    },
  });
};

export const useSubscription = (options = {}) => {
  return useQuery({
    queryKey: ['billing', 'subscription'],
    queryFn: api.getSubscription,
    ...options,
  });
};

export const useCancelScheduledChange = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: api.cancelScheduledChange,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['billing', 'subscription'] });
    },
  });
};

export const useCancelSubscription = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: api.cancelSubscription,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['billing', 'subscription'] });
    },
  });
};

// The returned url is pre-signed by Lemon Squeezy and expires after 24
// hours, so it's fetched fresh each time rather than cached/stored.
export const useBillingPortalUrl = () => {
  return useMutation({
    mutationFn: api.getBillingPortalUrl,
  });
};


